import app from 'flarum/forum/app';

import Component from "flarum/common/Component";
import LinkButton from "flarum/common/components/LinkButton";
import Button from "flarum/common/components/Button";

export default class InviteItem extends Component {

  private buttonName: string = 'expand'
  private class: string = ''
  private params: object = {}
  private inviteData: object = {}
  private chart: string[] = []
  private option: object[] = []
  private echartsType: string = 'invite'

  oninit(vnode) {
    super.oninit(vnode);

    this.inviteData = this.attrs.item.attributes
    this.params.id = this.inviteData.id
  }

  view() {
    let confirm = m('div', [
      m('div.spacing', [
        m('label', app.translator.trans('mattoid-store-invite.lib.item-confirm-user') + ': '),
        m('span', LinkButton.component({
          href: '/u/' + this.inviteData.confirmUser
        }, <img className="Invite-Icon" src={this.inviteData.confirmUserImg}/>)),
        m('span', LinkButton.component({
          href: '/u/' + this.inviteData.confirmUser
        }, this.inviteData.confirmUser)),
        m('span.horizontal-spacing', ' | '),
        m('label', app.translator.trans('mattoid-store-invite.lib.item-confirm-status') + ': '),
        m('span'  + (this.inviteData.status == 1 ? '.green' : this.inviteData.status == 2 ? '.red' :'.default'),
          this.inviteData.status == 1 ? app.translator.trans('mattoid-store-invite.lib.item-button-confirm') : this.inviteData.status == 2 ?
            app.translator.trans('mattoid-store-invite.lib.item-button-refuse') :
            app.translator.trans('mattoid-store-invite.lib.item-button-unaudited')),
        m('span.horizontal-spacing', ' | '),
        m('label', app.translator.trans('mattoid-store-invite.lib.item-confirm-time') + ': '),
        m('span', this.inviteData.confirmTime),
      ]),
      m('div.spacing', [
        m('label', app.translator.trans('mattoid-store-invite.lib.item-confirm-remark') + ': '),
        m('div', this.inviteData.confirmRemark)
      ]),
    ])
    if (this.inviteData.status == 0) {
      confirm = m('div', [
        m('div.spacing', [
          m('textarea.FormControl', {
            value: this.params.confirmRemark,
            rows: 5,
            onchange: (event: InputEvent) => {
              this.params.confirmRemark = (event.target as HTMLInputElement).value;
            },
          })
        ]),
        m('div.center', [
          m('div.Invite-Button', Button.component({
            type: 'submit',
            className: 'Button Button--primary Button--block',
            loading: this.loading,
            disabled: this.loading,
            onclick: () => {
              this.params.status = 1
              this.onsubmit()
            }
          }, app.translator.trans('mattoid-store-invite.forum.confirm-adopt'))),
          m('div.Invite-Button', Button.component({
            type: 'submit',
            className: 'Button Button--primary storeButton--gray',
            loading: this.loading,
            disabled: this.loading,
            onclick: () => {
              this.params.status = 2
              this.onsubmit()
            }
          }, app.translator.trans('mattoid-store-invite.forum.confirm-refuse')))
        ]),
      ])
    }

    return m('div.Invite-Body' + this.class , [
      m('.Form-group', [
        m('div', [
          m('div.rightAligned', Button.component(
            {
              onclick: () => {
                if (this.buttonName == 'expand') {
                  this.buttonName = 'retract'
                  this.class = ' .to.extended'
                  if (this.inviteData.status == 0) {
                    this.class = ' .article.extended'
                  }
                  this.echartsFun(this.inviteData.id, this.inviteData.userId);
                } else {
                  this.buttonName = 'expand'
                  this.class = ''
                }
              }
            },
            app.translator.trans('mattoid-store-invite.lib.item-button-' + this.buttonName)
          ))
        ]),
        m('div.spacing', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-user') + ': '),
          m('span' + (this.inviteData.notes > 0 ? '.red' : ''), LinkButton.component({
            href: '/u/' + this.inviteData.user
          }, <img className="Invite-Icon" src={this.inviteData.userImg}/>)),
          m('span' + (this.inviteData.notes > 0 ? '.red' : ''), LinkButton.component({
            href: '/u/' + this.inviteData.user,
            class: this.inviteData.notes > 0 ? 'red' : ''
          }, this.inviteData.user)),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-post-num') + ': '),
          m('span' + (this.inviteData.postNum < app.forum.attribute("postNum") ? '.red' : ''), this.inviteData.postNum),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-email') + ': '),
          m('span', LinkButton.component({
            href: "https://",
            onclick: () => {
              try {
                navigator.clipboard.writeText(this.inviteData.email);
                app.alerts.show({ type: 'success' }, app.translator.trans('mattoid-store-invite.forum.copy-email-success', {'email': this.inviteData.email}));
              } catch (e) {
                console.log(e)
                app.alerts.show({ type: 'error' }, app.translator.trans('mattoid-store-invite.forum.copy-email-error'));
              }
            }
          }, this.inviteData.email)),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-username') + ': '),
          m('span', this.inviteData.username),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-create-time') + ': '),
          m('span', this.inviteData.createdAt)
        ]),
        m('div.spacing', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-total-num') + ': '),
          m('span', this.inviteData.totalNum || 0),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-pass-total-num') + ': '),
          m('span', this.inviteData.passTotalNum || 0),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-reject-total-num') + ': '),
          m('span', this.inviteData.totalRejectlNum || 0),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-user-create-time') + ': '),
          m('span', this.inviteData.userCreateTime),
        ]),
        m('div.spacing', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-last-year-pass-num') + ': '),
          m('span', this.inviteData.lastYearPass || 0),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-last-year-reject-num') + ': '),
          m('span', this.inviteData.lastYearApply - this.inviteData.lastYearPass),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-this-year-pass-num') + ': '),
          m('span', this.inviteData.thisYearPass || 0),
          m('span.horizontal-spacing', ' | '),
          m('label', app.translator.trans('mattoid-store-invite.lib.item-this-year-reject-num') + ': '),
          m('span', this.inviteData.thisRejectlNum || 0),
        ]),
        m('div.spacing', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-link') + ': '),
          m('span', LinkButton.component({
            href: this.inviteData.link
          }, this.inviteData.link)),
        ]),
        m('div.spacing', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-link-2') + ': '),
          m('span', LinkButton.component({
            href: this.inviteData.link2
          }, this.inviteData.link2))
        ]),
        m('div.spacing.fixed', [
          m('label', app.translator.trans('mattoid-store-invite.lib.item-apply-rmark') + ': '),
          m('span', this.inviteData.applyRemark),
        ]),
        m('div.spacing', [
          <div id={"echarts-main-" + this.inviteData.id}></div>
        ]),
        confirm
      ])
    ])
  }

  echartsFun(id, userId) {
    let that = this;
    let iconImg = 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891'
    if (this.echartsType == 'invite') {
      iconImg = 'path://M594.304 684.8a21.333333 21.333333 0 0 0 0-30.165333L369.322667 429.653333a21.333333 21.333333 0 0 0-30.165334 0l-158.293333 158.293334a180.394667 180.394667 0 0 0 255.146667 255.146666l158.293333-158.293333zM654.634667 594.304a21.333333 21.333333 0 0 0 30.165333 0l158.293333-158.293333a180.394667 180.394667 0 0 0-255.146666-255.146667l-158.293334 158.293333a21.333333 21.333333 0 0 0 0 30.165334l224.981334 224.981333z'
    } else {
      iconImg = 'path://M511.435945 302.584307m-302.584307 0a302.584307 302.584307 0 1 0 605.168614 0 302.584307 302.584307 0 1 0-605.168614 0Z M803.763157 603.459098c-23.933222-18.804674-58.123539-17.095159-80.347245 5.128548-54.704508 54.704508-129.923205 88.894825-213.689483 88.894825s-158.984975-34.190317-213.689482-88.894825c-22.223706-22.223706-56.414023-25.642738-80.347245-5.128548C123.375845 682.096828 54.995211 782.958264 32.771505 921.429048c-8.547579 56.414023 30.771285 102.570952 88.894824 102.570952H902.915077c56.414023 0 97.442404-46.156928 88.894825-102.570952-23.933222-138.470785-92.313856-239.33222-188.046745-317.96995z'
    }

    if (!window.echarts) {
      setTimeout(() => this.echartsFun(id), 200);
      return;
    }

    const echartsMain = document.getElementById('echarts-main-' + id);
    if (!echartsMain) return;

    setTimeout(() => {
      this.chart[id] = window.echarts.init(echartsMain, null, {height: 300});

      if (!this.option[id]) {
        this.option[id] = {
          title: {
            text: app.translator.trans('mattoid-store-invite.forum.echarts.title'),
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          dataZoom: [
            {
              type: 'slider',
              start: 0,
              end: 100
            },
          ],
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack']},
              myInviteType: {
                show: true,
                title: '切换查询项',
                // icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                icon: iconImg,
                onclick: function () {
                  that.echartsType = that.echartsType === 'invite' ? '' : 'invite';
                  delete that.option[id];

                  that.echartsFun(id, userId);
                }
              },
              // saveAsImage: { show: true }
            }
          },
          legend: {
            data: []
          },
          xAxis: {
            type: 'category',
            axisTick: {show: false},
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: []
        };

        this.chart[id].showLoading();
        this.chart[id].setOption(this.option[id]);

        app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/store/invite/echarts/data?inviteId=' + id + '&userId=' + userId + '&type=' + this.echartsType,
        }).then(
          (result) => {
            this.chart[id].setOption({
              legend: {
                data: result.data.attributes.legend
              },
              xAxis: {
                data: result.data.attributes.xAxis
              },
              series: result.data.attributes.series
            });
            this.chart[id].hideLoading();
          },
          (result) => {
            this.chart[id].hideLoading();
            this.loading = false;
            this.handleErrors(result);
          });
      }
    });
  }

  onsubmit() {
    app.request({
      method: 'PUT',
      url: app.forum.attribute('apiUrl') + '/store/invite/edit',
      body: this.params
    }).then(
      () => {
        location.reload();
      },
      (result) => {
        this.loading = false;
        this.handleErrors(result);
      });
  }
}
